import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import { getScoreLabel } from '../../../../../../utils/shared/trcUtils';
import SectionHeader from '../../SectionHeader';
import RubricSection from './RubricSection';
import QuestionsSection from './QuestionsSection';
import { KEY } from '../../../../../../constants/shared/TrcConstants';

const { RUBRIC_TYPE, QUESTIONS_TYPE } = KEY;

const getSection = (oralCompResult, rubricMapper) => {
    switch (oralCompResult.oralCompType) {
        case RUBRIC_TYPE:
            return <RubricSection oralCompResult={oralCompResult} mapper={rubricMapper} />;
        case QUESTIONS_TYPE:
            return <QuestionsSection oralCompResult={oralCompResult} />;
        default:
            return null;
    }
};

const OralComprehensionTable = ({ oralCompResult, rubricMapper }) =>
    !isEmpty(oralCompResult) && (
        <section className="section-block">
            <SectionHeader
                titles={[
                    'Oral Comprehension',
                    // Remove this check if scope of CAT-16961
                    oralCompResult.oralCompType !== RUBRIC_TYPE &&
                        getScoreLabel(oralCompResult.actualScore, oralCompResult.maxScore),
                ]}
            />
            {getSection(oralCompResult, rubricMapper)}
        </section>
    );

OralComprehensionTable.defaultProps = {
    oralCompResult: {},
    rubricMapper: {},
};

OralComprehensionTable.propTypes = {
    oralCompResult: PropTypes.object,
    rubricMapper: PropTypes.object,
};

export default OralComprehensionTable;
